import { AccountTotals } from 'core/cuenta/models/AccountTotals';
import { ACCOUNT_AUTHORIZATIONS_PATH } from 'core/cuenta/routes';
import { useLocation, useNavigate } from 'react-router-dom';
import { LinkButton } from 'shared/components';
import { formatCurrency, formatParams } from 'shared/utils';
import { CARDS_TOTALS_BY_ACCOUNT_PATH } from 'core/tarjeta/routes';
import { Periodo } from 'shared/models/Periodo';
import { Table } from 'shared/table';
import { useNotifications } from 'shared/notifications';

export const AccountsTotalsTable = (props: {
  tableContent: AccountTotals[];
  totals: AccountTotals;
  periodo: Partial<Periodo>;
}) => {
  const navigate = useNavigate();
  const { addNotification } = useNotifications();
  const location = useLocation();

  const clickAccountHandler = (total: AccountTotals) => {
    navigate(
      {
        pathname: CARDS_TOTALS_BY_ACCOUNT_PATH.replace(
          ':accountNumber',
          total.numeroCuenta,
        ),
        search: formatParams(props.periodo),
      },
      {
        state: {
          fromAccountTotals: true,
        },
      },
    );
  };

  const handleAuthorizations = (item: any) => {
    if (item.autorizaciones <= 0) {
      addNotification('No hay autorizaciones para esta cuenta', 'error');
    } else {
      navigate(ACCOUNT_AUTHORIZATIONS_PATH.replace(':accountNumber', item.numeroCuenta), {
        state: {
          accountTotals: true,
          previous: location.pathname,
        },
      });
    }
  };
  return (
    <Table
      thead={
        <>
          {props.periodo !== null || (
            <tr>
              <td colSpan={2} align="center"></td>
              <td colSpan={8} align="center">
                Saldos al día de ayer
              </td>
              <td colSpan={2} align="center">
                Saldos al día de hoy
              </td>
            </tr>
          )}
          <tr>
            <td align="center" rowSpan={2}>
              Cuenta
            </td>
            <td align="center" rowSpan={2}>
              Denominación
            </td>
            <td align="center" rowSpan={2}>
              Saldo Inicial
            </td>
            <td align="center" colSpan={2}>
              Transferencias
            </td>
            <td align="center" rowSpan={2}>
              Acredit.
            </td>
            <td align="center" rowSpan={2}>
              Otros
            </td>
            <td align="center" rowSpan={2}>
              Extracciones
            </td>
            <td align="center" rowSpan={2}>
              Consumos
            </td>
            <td align="center" rowSpan={2}>
              Saldo
            </td>
            {props.periodo !== null || (
              <>
                <td align="center" rowSpan={2}>
                  Autoriz.
                </td>
                <td align="center" rowSpan={2}>
                  Disp.
                </td>
              </>
            )}
          </tr>
          <tr>
            <td align="center">Crédito</td>
            <td align="center">Débito</td>
          </tr>
        </>
      }
      tbody={
        <>
          {props.tableContent.map((item, index) => (
            <tr key={'total' + item.numeroCuenta} data-testid={'account-row-' + index}>
              <td className="align-right">
                <LinkButton onClick={() => clickAccountHandler(item)}>
                  {item.numeroCuenta}
                </LinkButton>
              </td>
              <td className="align-left">{item.denominacionCuenta}</td>
              <td className="align-right">{formatCurrency(item.saldoInicial)}</td>
              <td className="align-right">{formatCurrency(item.transferenciaCredito)}</td>
              <td className="align-right">{formatCurrency(item.transferenciaDebito)}</td>
              <td className="align-right">{formatCurrency(item.acreditaciones)}</td>
              <td className="align-right">{formatCurrency(item.otros)}</td>
              <td className="align-right">{formatCurrency(item.adelantos)}</td>
              <td className="align-right">{formatCurrency(item.consumos)}</td>
              <td className="align-right">{formatCurrency(item.saldoActual)}</td>
              {props.periodo !== null || (
                <>
                  <td className="align-right">
                    <LinkButton
                      data-testid="authorizations-button"
                      onClick={() => handleAuthorizations(item)}
                    >
                      {formatCurrency(item.autorizaciones)}
                    </LinkButton>
                  </td>
                  <td className="align-right">{formatCurrency(item.saldoDisponible)}</td>
                </>
              )}
            </tr>
          ))}
        </>
      }
      tfoot={
        <tr className="totals" key={'totals'} data-testid={'account-total'}>
          <td className="align-right" colSpan={2}>
            Total General
          </td>
          <td className="align-right">{formatCurrency(props.totals.saldoInicial)}</td>
          <td className="align-right">
            {formatCurrency(props.totals.transferenciaCredito)}
          </td>
          <td className="align-right">
            {formatCurrency(props.totals.transferenciaDebito)}
          </td>
          <td className="align-right">{formatCurrency(props.totals.acreditaciones)}</td>
          <td className="align-right">{formatCurrency(props.totals.otros)}</td>
          <td className="align-right">{formatCurrency(props.totals.adelantos)}</td>
          <td className="align-right">{formatCurrency(props.totals.consumos)}</td>
          <td className="align-right">{formatCurrency(props.totals.saldoActual)}</td>
          {props.periodo !== null || <td className="align-right" colSpan={2}></td>}
        </tr>
      }
    />
  );
};
